import React , { useState , useEffect } from 'react'


import Layout from '../../components/layout/layout'
import CustomSplitter from '../../components/splitter/splitter'
import GenericGrid from '../../components/grid/grid'
import GenericTabStrip from '../../components/tabs/tabs';

import General from './general/general';
import AnalysisSet from './analysis-set/analysis-set';

import { menuItem , renderColumns } from '../../utils/helper';


import "./index.css"


const dummyData = [
    {
        id:"1",
        nctNumber:"NCT XXXX01",
        title:"Title XXXX"
    },
    {
        id:"2",
        nctNumber:"NCT XXXX02",
        title:"Title XXXX"
    },
    {
        id:"3",
        nctNumber:"NCT XXXX03",
        title:"Title XXXX"
    },
    {
        id:"4",
        nctNumber:"NCT XXXX04",
        title:"Title XXXX"
    },
    {
        id:"5",
        nctNumber:"NCT XXXX05",
        title:"Title XXXX"
    },
    {
        id:"6",
        nctNumber:"NCT XXXX06",
        title:"Title XXXX"
    },
    {
        id:"7",
        nctNumber:"NCT XXXX07",
        title:"Title XXXX"
    },
    {
        id:"8",
        nctNumber:"NCT XXXX08",
        title:"Title XXXX"
    },
    {
        id:"9",
        nctNumber:"NCT XXXX09",
        title:"Title XXXX"
    },
    {
        id:"10",
        nctNumber:"NCT XXXX10",
        title:"Title XXXX"
    },
    {
        id:"11",
        nctNumber:"NCT XXXX11",
        title:"Title XXXX"
    },
    {
        id:"12",
        nctNumber:"NCT XXXX12",
        title:"Title XXXX"
    },
    {
        id:"13",
        nctNumber:"NCT XXXX12",
        title:"Title XXXX"
    },
    {
        id:"14",
        nctNumber:"NCT XXXX12",
        title:"Title XXXX"
    },
]

const RightHeader = ( {selectedGridRow} ) => {
 
  return (
      <div className='header'>
          <span> { selectedGridRow.nctNumber } </span>
          <span> { selectedGridRow.title } </span>
      </div>
  )
}


const RightContent = () => {
  const [tabs, setTabs] = useState([
    { id: "tab1", title: "General", content:<General/> },
    { id: "tab2", title: "Analysis Set", content:<AnalysisSet/> },
    { id: "tab3", title: "Demographics and Baseline", content: <div>Settings Content</div>, },
    { id: "tab4", title: "Medical History", content: <div>Settings Content</div>, },
    { id: "tab5", title: "Concomitant Medication", content: <div>Settings Content</div>, },
    { id: "tab6", title: "Endpoint", content: <div>Settings Content</div>, },
    { id: "tab7", title: "Statistical Methods", content: <div>Settings Content</div>, },
    { id: "tab8", title: "Adverse Events", content: <div>Settings Content</div>, },
  ]);

  const handleTabChange = (tab, idx) => {
    console.log("Selected tab:", tab, "Index:", idx);
  };

  return (
    <div style={{marginTop:"5px"}}>
      <GenericTabStrip
        tabs={tabs}
        onTabChange={handleTabChange}
        closable={false}
        style = { { height:"calc( 100vh - 50px )" }}
      />
    </div>
  );
};


const Studies = () => {

 const [dataState, setDataState] = useState({
  skip: 0,
  take: 100,
  sort: [],
  filter: null
});

const [ data , setData ] = useState( dummyData )

const [ selectedGridRow , setSelectedGridRow ] = useState( {} )


const handleSelectionChange = (event) => {
  const newData = data.map(item => ({
    ...item,
    selected: item.id === event.dataItem.id
  }));

  const selectedItem = newData.find( item => item.selected )

  setData(newData);
  
  setSelectedGridRow( selectedItem ? selectedItem : {}  )

  localStorage.setItem( "studies_Sel_row" , JSON.stringify( selectedItem ? selectedItem : {} ) )

};

const handleDataStateChange = (e) => {
  setDataState(e.dataState);
}

const columns = [
  {
    title: "Studies", 
    children: [
      { field: "nctNumber" ,    headerCell: () => <th style={{display:"none"}}></th> },
      { field: "title" ,    headerCell: () => <th style={{display:"none"}}></th>},
  
    ]
  }
];

useEffect(()=>{
   const storedgridRow = JSON.parse( localStorage.getItem( "studies_Sel_row" ) )
   if( storedgridRow ) setSelectedGridRow( storedgridRow )
},[])

  return (
    <>
        <Layout menuItem = { menuItem }  location={"/studies"} >
         <CustomSplitter>
            <div className='studies-grid-con'>
             <GenericGrid
               data={data}
               columns={renderColumns(columns)}
               dataState={dataState}
               onDataStateChange={handleDataStateChange}
               pageable={false}
               sortable={false}
               filterable={false}
               style={{ height:"100vh" }}
               dataItemKey = { "id" }
              selectable={{
                        enabled: true,
                        mode: "single",
                        drag: false,
                        cell: false}}
               onSelectionChange={handleSelectionChange}
               selectedRow = { selectedGridRow }
               storageField = {"studies_Sel_row"}
               />
            </div>
           <div className='studies-right-con'>
              <RightHeader selectedGridRow = { selectedGridRow } />
              <RightContent/>
           </div>
         </CustomSplitter>
        </Layout>
    </>
  )
}

export default Studies